import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import is from "./filter-set.js";
var us = /*#__PURE__*/function () {
  function us(t, s) {
    _classCallCheck(this, us);
    this.productId = t, this.tf = s, this.productId = t, this.tf = s;
  }
  _createClass(us, [{
    key: "xc",
    value: function xc(t) {
      if (null == this.productId || null == this.tf) return !1;
      var s = t[0],
        i = t[1];
      return s === this.productId && this.tf.xc(i);
    }
  }, {
    key: "dt",
    value: function dt() {
      return {
        id: this.productId,
        pf: this.tf ? this.tf.dt() : null
      };
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new us(t ? t.product_id : null, t ? is.fromJson(t.property_filters) : null);
    }
  }]);
  return us;
}();
export { us as default };